import Types from "./Types";

const INIT_STATE = {
  promoCodes: [],
  promoCode: {},
  count: 0,
  load: null,
};

export function promoCodesReducer(state = INIT_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case Types.PROMO_CODES_LOADING: {
      return {
        ...state,
        load: payload,
      };
    }
    case Types.GET_PROMO_CODES_SUCCESS: {
      return {
        ...state,
        promoCodes: payload?.data?.promo_codes,
        count: payload?.extra?.total_count,
      };
    }
    case Types.GET_PROMO_CODE_DETAILS_SUCCESS: {
      return {
        ...state,
        promoCode: payload?.data?.promo_code,
      };
    }
    default: {
      return state;
    }
  }
}
